import { render, staticRenderFns } from "./Classroom.vue?vue&type=template&id=a461b356&scoped=true"
import script from "./Classroom.vue?vue&type=script&lang=js"
export * from "./Classroom.vue?vue&type=script&lang=js"
import style0 from "./Classroom.vue?vue&type=style&index=0&id=a461b356&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a461b356",
  null
  
)

export default component.exports